/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 提交订单获取优惠劵列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  couponsReqDto: good.CouponsReqDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.CouponInfoResDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/coupons`,
    data: couponsReqDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
